import React from 'react';

import { Container } from './styles';

function Footer() {
  return (
    <Container>
      <strong>© 2020</strong> Feito com 💙 por{' '}
      <a
        href="https://linktr.ee/jpcmf"
        target="_blank"
        rel="noopener noreferrer"
      >
        João Paulo Fricks.
      </a>
    </Container>
  );
}

export default Footer;
